export default __webpack_public_path__ + "static/media/chris-li-6Y6OnwBKk-o-unsplash.730fb323.jpg";